import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import InvoiceList from '../../components/subscription/InvoiceList';

const InvoicesPage = () => {
  return (
      <Container fluid className="py-4">
        <h1 className="h3 mb-4">Billing History</h1>
        
        <Row>
          <Col lg={10} xl={8}>
            <InvoiceList />
          </Col>
        </Row>
      </Container>
  );
};

export default InvoicesPage;
